import { useRef, useEffect } from "react";
const useRefObserver = ({ targetRef, cb }) => {
  const prevRef = useRef(null);
  const callbackRef = useRef(cb);
  useEffect(() => {
    callbackRef.current = cb;
  });
  useEffect(() => {
    const updateRef = (node) => {
      if (node !== prevRef.current) {
        prevRef.current = node;
        callbackRef.current(node);
      }
    };
    if (typeof targetRef === "function") {
      targetRef(null);
      updateRef(null);
    } else if (targetRef && "current" in targetRef) {
      updateRef(targetRef.current);
    }
  });
  useEffect(() => {
    return () => callbackRef.current(null);
  }, []);
};
const RefObserver = (props) => {
  useRefObserver(props);
  return null;
};
export {
  RefObserver,
  useRefObserver
};
